import React from 'react';
import Grid from "@mui/material/Grid";
import {Container, Paper, TextField} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import {format} from "date-fns";
import Typography from "@mui/material/Typography";
import {useDispatch, useSelector} from "react-redux";
import {setExtraActivities} from "../../../redux/actions/transactionActions";
import NautilusText from "../../Common/NautilusText";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginBottom:theme.spacing(8)
    },
    mainContainer:{
        padding:  0,
        boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)"
    },
    paper: {
        padding: theme.spacing(0),
        width: '100%',
        margin: 'auto',
    },

}));

const ExtraActivityDate = (date) => {
    const nd = new Date(date);
    return format(nd, 'h:mm a') !== '12:00 AM' ? format(nd, "h:mmaa - LLLL d, yyyy"): format(nd, "LLLL d, yyyy");
};
const ExtraActivity = ({activity}) => {
    const {extra} = useSelector(state => state.transactions);
    const classes = useStyles();
    const dispatch = useDispatch();

    const currentValue = extra[activity.id] || '';

    const handlerActivity = (event) => {
        const availabilityId = event.target.value;
        dispatch(setExtraActivities(activity.id, availabilityId, availabilityId !== ''));
    }

    return (
        <div className={classes.root}>
            <Container maxWidth='lg' className={classes.mainContainer}>
                <Paper className={classes.paper} elevation={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} className="roomContainer" style={{display: 'flex', alignContent: 'center'}} >
                            <img src={activity['image']} alt="Activity" width={'100%'}
                                 className={'activityImage'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} className="ActivityContainer" justify="left">
                            <Typography variant="h3" align="left" style={{padding:'10px',fontSize:'22px'}}>
                                {`${activity['name']} ($${parseFloat(activity['price']).formatMoney(0)}/person)`}
                            </Typography>
                            <Typography variant="h5" align="left" style={{padding:'10px 12px 10px'}}>
                                {activity['description'].split('##More Information')[0]}
                            </Typography>
                            <NautilusText name="source" value={currentValue} variant="outlined" select
                                          onChange={handlerActivity}
                                          SelectProps={{native: true,}} style={{padding:'10px 12px 10px'}}>
                                <option value="">Select your date </option>
                                {activity && 'availabilities' in activity &&
                                Object.keys(activity['availabilities']).length > 0 &&
                                Object.keys(activity['availabilities']).map((dates) => (
                                    <option key={dates} value={dates}>
                                        {ExtraActivityDate(activity['availabilities'][dates]['date'])}
                                    </option>
                                ))}
                            </NautilusText>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </div>
    );
};

export default ExtraActivity;
